import React, { useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Switch, useLocation } from "react-router-dom";

import Homepage from "../HomePage";

import { useDispatch } from "react-redux";
import EventsDatils from "../../components/EventsDatils";
import Navbar2 from "../../components/Navbar2";
import { GET_MENUS_ALL_NESTED } from "../../constant/constants";
import { useLoader } from "../../context";
import Loader from "../../context/Loder";
import { getAllmenus, getSiteSetting } from "../../dataSlice/dataSlice";
import AboutPage from "../AboutPage";
import AdvisorPage from "../AdvisorPage";
import BackgroundPage from "../BackgroundPage";
import BlogDetails from "../BlogDetails";
import BlogDetailsFull from "../BlogDetailsFull";
import BlogDetailsLeftSiide from "../BlogDetailsLeftSiide";
import BlogPage from "../BlogPage";
import BlogPageFullwidth from "../BlogPageFullwidth";
import BlogPageLeft from "../BlogPageLeft";
import BlogSinglePage from "../BlogSinglePage";
import CausePage from "../CausePage";
import CauseSinglePage from "../CauseSinglePage";
import ClientsPage from "../ClientsPage";
import CompanyPage from "../CompanyPage";
import ContactPage from "../ContactPage";
import DocumentPage from "../DocumentPage";
import DonatePage from "../DonatePage";
import ErrorPage from "../ErrorPage";
import EventPage from "../EventPage";
import EventPage2 from "../EventPage2";
import EventSinglePage from "../EventSinglePage";
import EventSinglePage2 from "../EventSinglePage2";
import ExecutivePage from "../ExecutivePage";
import ForgotPassword from "../ForgotPassword";
import FormPage from "../FormPage";
import GalleryPage from "../GalleryPage";
import HistoryPage from "../HistoryPage";
import LifeMemberPage from "../LifeMemberPage";
import LiveProgramPage from "../LiveProgramPage";
import LiveProgramSinglePage from "../LiveProgramSinglePage";
import LoginPage from "../LoginPage";
import MemberPage from "../MemberPage";
import MissionPage from "../MissionPage";
import NewsDatils from "../NewsDatils";
import NewsPage from "../NewsPage";
import PerformancePage from "../PerformancePage";
import PreviousProgramPage from "../PreviousProgramPage";
import ProfilePage from "../ProfilePage";
import ProjectPage from "../ProjectPage";
import ProjectSinglePage from "../ProjectSinglePage";
import ServicePage from "../ServicePage";
import SeviceSinglePage from "../SeviceSinglePage";
import SignUpPage from "../SignUpPage";
import TeamSinglePage from "../TeamSinglePage";
import TestimonialPage from "../TestimonialPage";
import VolunteerPage from "../VolunteerPage";




const AllRoute = ( { logo } ) =>{
  let location = useLocation();

  const [ homeId, setHomeId ] = useState();

  const dispatch = useDispatch();
  const { showLoader, isLoading } = useLoader();

  console.log( "location", location );

  useEffect(() => {
    showLoader(); 
   
   return null; // Routes are handled elsewhere

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect( () =>
  {
    fetch( `${ GET_MENUS_ALL_NESTED }` )
      .then( ( response ) => response.json() )
      .then( ( data ) =>
      {
        data.menus.find( ( e ) => ( e.name === "Home" ? setHomeId( e.id ) : null ) );
      } )
      .catch( () => { } );
    dispatch( getAllmenus() );
    dispatch( getSiteSetting() );
    
  }, [ dispatch ] );
  

 
  return (
    <div className="App">
      <Router>
        
      <Loader />
        <div
       style={{ display: !isLoading ? 'block' : 'none' }}
        >
        <Navbar2
          Logo={ logo }
          id={ homeId }
          hclass={ "wpo-header-style-4 text-nowrap" }
        />

        <Switch>
          <Route exact path="/" component={ Homepage } />
          <Route path="/home/:id" component={ Homepage } />

          <Route path="/about/:id" component={ AboutPage } />
          <Route path="/service/:id" component={ ServicePage } />
          <Route path="/clients/:id" component={ ClientsPage } />
          <Route path="/service-single/:id" component={ SeviceSinglePage } />
          <Route path="/message/:id" component={ EventSinglePage2 } />
          <Route path="/mission/:id" component={ MissionPage } />
          <Route path="/background/:id" component={ BackgroundPage } />
          <Route path="/history/:id" component={ HistoryPage } />
          <Route path="/performance/:id" component={ PerformancePage } />
          <Route path="/gallery/:id" component={ GalleryPage } />
          <Route path="/executive committee/:id" component={ ExecutivePage } />
          <Route path="/life member/:id" component={ LifeMemberPage } />
          <Route path="/form/:id" component={ FormPage } />
          <Route path="/all member/:id" component={ MemberPage } />
          <Route path="/member/:id" component={ MemberPage } />
          <Route path="/advisor/:id" component={ AdvisorPage } />
          <Route path="/document/:id" component={ DocumentPage } />
          <Route path="/company/:id/:companyName?" component={ CompanyPage } />
          <Route path="/cause/:id" component={ CausePage } />
          <Route path="/cause-single/:id" component={ CauseSinglePage } />
          <Route path="/team-single/:id" component={ TeamSinglePage } />
          <Route path="/event/:id" component={ EventPage } />
          <Route path="/event-s2" component={ EventPage2 } />
          <Route path="/event-single/:id" component={ EventSinglePage } />
          <Route path="/project" component={ ProjectPage } />
          <Route path="/project-single/:id" component={ ProjectSinglePage } />
          <Route path="/live Event/:id" component={ LiveProgramPage } />
          <Route path="/previous Event/:id" component={ PreviousProgramPage } />
          <Route path="/program/:id" component={ LiveProgramPage } />
          <Route
            path="/live Program-single/:id/:projectName"
            component={ LiveProgramSinglePage }
          />
          {/* <Route
            path="/blogs Program-single/:id/:projectName"
            component={BlogSinglePage}
          /> */}
          <Route
            path="/blogs details/:id/:blogName"
            component={ BlogSinglePage }
          />
          <Route
            path="/event details/:id/:eventName"
            component={ EventsDatils }
          />
          <Route
            path="/news details/:id/:newsName"
            component={ NewsDatils }
          />
          <Route
            path="/Previous Program-single/:id/:projectName"
            component={ LiveProgramSinglePage }
          />
          <Route path="/testimonial" component={ TestimonialPage } />
          <Route path="/blog-single/:id" component={ BlogDetails } />
          <Route
            path="/blog-single-left-sidebar/:id"
            component={ BlogDetailsLeftSiide }
          />
          <Route
            path="/blog-single-fullwidth/:id"
            component={ BlogDetailsFull }
          />
          {/* <Route path="/blogs" component={OurBlogs} /> */ }
          <Route path="/news" component={ NewsPage } />
          <Route path="/blogs/" component={ BlogPage } />
          <Route path="/blog-left-sidebar" component={ BlogPageLeft } />
          <Route path="/blog-fullwidth" component={ BlogPageFullwidth } />
          <Route path="/donate/:id/:causeName" component={ DonatePage } />
          <Route path="/volunteer" component={ VolunteerPage } />
          <Route path="/404" component={ ErrorPage } />
          <Route path="/contact" component={ ContactPage } />
          {/* 
            <Route path='/attorneys' component={AttorneysPage} />
            <Route path='/pricing' component={PricingPage} />
            <Route path='/practice' component={PracticePage}/>
            <Route path='/practice-s2' component={PracticePageS2}/>
            <Route path='/case-single/:id' component={caseSinglePage}/>
            <Route path='/shop' component={ShopPage}/>
            <Route path='/shop-single/:id' component={ShopSinglePage}/>
            <Route path='/cart' component={CartPage}/>
            <Route path='/checkout' component={CheckoutPage}/>
            <Route path='/faq' component={FaqPage}/>
            */}
          <Route path="/login" component={ LoginPage } />
          <Route path="/profile" component={ ProfilePage } />
          <Route path="/register" component={ SignUpPage } />
          <Route path="/forgot-password" component={ ForgotPassword } />
        </Switch>
        </div>
      </Router>
    </div>
  );
};

export default AllRoute;
